import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import ScaleLoader from '../Components/ScaleLoader';

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - ${legacyTheme.props.headerHeight});
  ${legacyTheme.breakpoints.match('sm')} {
    min-height: ${legacyTheme.props.fullHeight};
  }
`;

const Loading = ({ pastDelay }) => (
  <Root>
    {pastDelay && <ScaleLoader color={theme.colors.neutral['900']} margin="5px" size="40px" />}
  </Root>
);

Loading.defaultProps = {
  pastDelay: true,
};

Loading.propTypes = {
  pastDelay: PropTypes.bool,
};

export default Loading;
